import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { PrProfileContext } from "../../data/pr_profile_context_management";
import usePrRepresentationsApi from "../../data/use_pr_representations_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import AddProductInput from "./add_product_card/AddProductInput";

// The Add surface for represented products. Only the picker lives here: removal happens inline on the
// page's RepresentsSection, so this body does not restate the represented list. A successful add
// requests the Products tab and closes.
function ProductsModalBody({ close }) {
  const context = useContext(PrProfileContext);
  const { representedProducts, generalError, setActiveTabRequest } = context;
  const { addProduct } = usePrRepresentationsApi({ ...context });

  const excludedProductIds = (representedProducts || []).map((product) => product.id);

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} />
        <div className="row g-2">
          <AddProductInput
            existingProductsIds={excludedProductIds}
            onSubmit={async (productId) => {
              // Stay open on failure so the alert above is what the viewer sees, not a vanished modal.
              const { saved } = await addProduct(productId);
              if (saved) {
                setActiveTabRequest("products");
                close();
              }
            }}
            onCancel={close}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default ProductsModalBody;
